exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".clickable {\r\n    cursor: pointer;\r\n    width: 100%;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.skillsets-container :hover {\r\n    background-color: lightgray;\r\n    cursor: pointer;\r\n}\r\n\r\n.products {\r\n    cursor: text !important;\r\n    background-color: white !important;\r\n    margin: 5px;\r\n}\r\n\r\n.products:hover {\r\n        cursor: text !important;\r\n        background-color: white !important\r\n    }\r\n\r\n.skillsets-container {\r\n    height: auto;\r\n    margin: 1em;\r\n}\r\n\r\n@media only screen and (min-width: 1200px) {\r\n    .skillsets-container {\r\n        height: auto;\r\n        margin: 1em;\r\n        width: 98%;\r\n        float: left;\r\n        display: block;\r\n    }\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/Uhm.Loops.Web/src/app/collateralskillsets/property-types/property-types.component.css
// module id = ../../../../../src/app/collateralskillsets/property-types/property-types.component.css
// module chunks = main